module.exports = __webpack_public_path__ + "static/img/UZ.f6eea83f.svg";